<template>
  <div id="app">

    <div id="top-header" class="top-header">
      <!--
      <p onclick="$('html').animate({scrollTop: $('#about-me-section').position().top }, 'slow')">Spinning House Investment Property</p>
      <p onclick="$('html').animate({scrollTop: $('#what-i-do-section').position().top }, 'slow')">HOME</p>
      -->

      <div class="header-icons">
        <a href="https://www.facebook.com/spinninghouseinvestmentproperty/" target="_blank">
          <img src="./assets/facebook-icon.jpg">
        </a>
        <a href="https://www.instagram.com/tomasz_tcho/" target="_blank">
          <img src="./assets/insta-icon.jpg">
        </a>
        <a href="https://www.youtube.com/channel/UCR2AeQRVSNov5cKVbXGxWew?fbclid=IwAR18vYTGNxFjvbZXZm7FYlZt3fxCCUQ5IfJ728MG47-ypeJmuubBxQ2yKus" target="_blank">
          <img src="./assets/youtube-icon.jpg">
        </a>
      </div>
    </div>

    <div style="position: absolute; left: 40px; top: 60px; z-index: 9">
      <img src="./assets/Spinning_House_Logo_Property.jpg" style="width: 80px; display: inline-block;">
      <h2 style="display: inline-block; width: 260px; text-align: left; padding: 0 10px 20px 10px; color: #111; position: relative; bottom: 10px;">Spinning House Investment Property</h2>
    </div>
    <div class="maximize-money">
      <h1>Maximise your money through property</h1>
      <h3>Free Consultation</h3>

      <button class="transparent-button" v-on:click="scrollToRegister">Register your Interest</button>
    </div>

    <router-view/>


  </div>
</template>

<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }

  body, html {
    height: 100%;
    margin: 0;
    font: 400 15px/1.8 "Lato", sans-serif;
    color: #777;
  }

  button {
    color: #1d1e21;
    border-radius: 20px;
    width: 200px;
    font-weight: bold;
  }

  button {
    border-width: 0;
    background-color: #fff;
    height: 40px;
    margin: 20px 0;
  }

  form {
    max-width: 400px;
    margin: auto;
  }

  input, textarea {
    width: 300px;
  }
  label {
    display: block;
    text-align: left;
    font-weight: bold;
    padding-left: 50px;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  a img {
    padding: 10px;
    filter: invert(1);
  }

  a:hover img {
    transform: scale(1.2)
  }

  .transparent-button {
    background-color: transparent;
    border-style: solid;
    border-width: 2px;
    border-color: #222;
  }

  #contact-form {
    padding-bottom: 20px;
  }

  #stay-updated-confirmation {
    color: #222;
  }

  .header-icons {
    width: 200px;
    display: inline-block;
    float: right;
    padding: 6px;
  }

  #top-header {
    width: 100%;
    top: 0;
    z-index: 999;
    width: 100%;
    position: fixed;
  }

  #my-vlog-section {
    color: #777;
    background-color: white;
    text-align: center;
    padding: 50px 80px;
    overflow-x: scroll;
  }

  .maximize-money {
    position: absolute;
    left: 80px;
    top: 240px;
    z-index: 2;
    text-align: left;
    color: #222;
  }

  .maximize-money h1 {
    font-size: 42px;
    line-height: 1;
  }

  .bgimg-1,
  .bgimg-2,
  .bgimg-3,
  .bgimg-4 {
    position: relative;
    opacity: 0.45;
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

  }

  .bgimg-2 {
    background-image: url("assets/2.jpg");
    filter: grayscale(1);
    min-height: 600px;
    z-index: -1;
  }

  .bgimg-5 {
    min-height: 400px;
    text-align: center;
    color: #fff;
  }

  .text-wrapper {
    max-width: 600px;
    margin: auto;
  }

  .what-i-do-table {
    padding: 10px;
    max-width: 1000px;
    margin: auto;
  }

  .what-i-do-table td {
    padding: 10px 20px;
  }

  .footer {
    color: #222;
    text-align: center;
    padding: 10px 20px 4px;
    bottom: 0;
  }

  .section-slogan {
    text-align: center;
    letter-spacing: 0.8em;
    font-family: monospace;
    margin: 0 10px 60px;
  }

  .stay-updated-box {
    width: 400px;
    margin: 0;
    display: inline-block;
    vertical-align: top;
  }

  .stay-updated-box a img {
    filter: invert(90%);
  }

  .stay-updated-box-underline {
    border-style: solid;
    border-width: 0 0 1px 0;
    margin: 20px;
  }

  .contact-me-frame {
    height: 600px;
    width: 100%;
    overflow-x: hidden;
    position: absolute;
    z-index: -1;
    background-position: center;
    opacity: 0.5;
  }

  .contact-bg-img {
    position: relative;
    height: 100%;
    opacity: 0.4;
    left: 0;
  }

  .caption {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    text-align: center;
    color: #000;
  }

  .caption span.border {
    background-color: #111;
    color: #fff;
    padding: 18px;
    font-size: 25px;
    letter-spacing: 10px;
  }

  h3 {
    letter-spacing: 5px;
    text-transform: uppercase;
    font: 20px "Lato", sans-serif;
    color: #111;
  }

  .name-header {
    width: 100%;
    text-align: center
  }

  .top-header p {
    display: inline-block;
    padding: 2px 20px;
    font-family: monospace;
  }

  /* Turn off parallax scrolling for tablets and phones */
  @media only screen and (max-device-width: 1024px) {
    .bgimg-1, .bgimg-2, .bgimg-3 {
      background-attachment: scroll;
    }
  }

  /* loading spinner */
  .loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #222;
    width: 60px;
    height: 60px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    position: relative;
    margin: 20px auto;
    left: 0;
    right: 0;
  }

  /* Safari */
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

</style>

<script>
import JQuery from 'jquery'
let $ = JQuery

export default {
  name: 'App',
  methods: {
    scrollToRegister: () => {
      console.log('I would like to register my interest pls', $)
      $([document.documentElement, document.body]).animate({
        scrollTop: $('#signup-container').offset().top
      }, 2000)
    }
  }
}
</script>
